import React, { useEffect, useRef, useContext } from 'preact/compat';

import PathChangeContext from 'Flyout/Contexts';
import Accordion from 'Flyout/components/Accordion';

export default function Node(props) {
    const {
        object, treeState, className, children,
    } = props;

    // the reference to the DOM element
    const elemRef = useRef();
    const navigationContext = useContext(PathChangeContext);

    // if this is the active element, hand over the active DOM element to the navigation
    useEffect(() => {
        if (object === treeState.activeObject) {
            navigationContext.activeElem(elemRef.current);
        }
    }, [treeState.activeObject]);

    const current = treeState.treeOpen && object === treeState.nextObject;

    // Assemble the class names
    const classNames = [];
    if (className) {
        classNames.push(className);
    }
    if (object === treeState.activeObject) {
        classNames.push('active');
    }
    if (current) {
        classNames.push('current');
    }

    // Render the unit inside of a Accordion that will handle the open/close state
    return (
        <li className={classNames.join(' ')} ref={elemRef}>
            <Accordion object={object} treeState={treeState}>
                { children }
            </Accordion>
        </li>
    );
}
